import React, { useEffect, useRef, useState } from 'react'

import "./scenario-info-ui.css"
import { UIProperties } from '../../cvp-webgames-core/Components/ui/UIProperties';
import CoreArrow1 from '../../cvp-webgames-core/Components/ui/react/core-arrow1';
import { SingleScenarioConfig } from '../../cvp-webgames-core/Misc/interfaces';
import { AnimationPage } from '../../cvp-webgames-core/UI/Animation/animation-page';
import { VideoSegmentItem, SingleVideoSegmentItem } from '../../cvp-webgames-core/VideoSegment/VideoSegmentItem';
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../cvp-webgames-core/pre-caching/pre-cache-item';
import { constants } from '../../misc/constants';
import { parseDynamicHtml, TextHtmlTagType, PageType } from '../../misc/tools';
import Button2 from '../general/button2';
import PopUp2 from '../general/pop-up2';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import MediaControlsUI from './media-controls-ui';
import MentorUI from './mentor-ui';
const mediaId = Tools.generateGuid()

class ScenarioInfoWindowCaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'scenario-hero',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/sample-image.png'
			},
			{
				type: PrecacheItemType.Image,
				key: 'return1',
				src: process.env.PUBLIC_URL + '/assets/images/return1.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'lock-locked',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/lock-locked.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'lock-unlocked',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/lock-unlocked.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'scen-icon',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/scenario-icon.svg'
			}
		];
	}
}

export const scenarioInfoWindowCaching = new ScenarioInfoWindowCaching();

class ScenarioInfoWindowVideoCaching extends VideoSegmentItem {
	public getItems(): SingleVideoSegmentItem[] {
		return [
			{
				key: 'scenario1',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario01/sc01-mentor/mntr-sc-01.mp4',
				type: PrecacheItemType.Video
			},{
				key: 'scenario2',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario01/sc01-mentor/mntr-sc-02.mp4',
				type: PrecacheItemType.Video
			},{
				key: 'scenario3',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario01/sc01-mentor/mntr-sc-03.mp4',
				type: PrecacheItemType.Video
			},{
				key: 'scenario4',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario01/sc01-mentor/mntr-sc-04.mp4',
				type: PrecacheItemType.Video
			},{
				key: 'scenario5',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario01/sc01-mentor/mntr-sc-05.mp4',
				type: PrecacheItemType.Video
			},{
				key: 'scenario6',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario01/sc01-mentor/mntr-sc-06.mp4',
				type: PrecacheItemType.Video
			},{
				key: 'scenario7',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario01/sc01-mentor/mntr-sc-07.mp4',
				type: PrecacheItemType.Video
			},{
				key: 'scenario8',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario01/sc01-mentor/mntr-sc-08.mp4',
				type: PrecacheItemType.Video
			},{
				key: 'scenario9',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario01/sc01-mentor/mntr-sc-09.mp4',
				type: PrecacheItemType.Video
			},{
				key: 'scenario10',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario01/sc01-mentor/mntr-sc-10.mp4',
				type: PrecacheItemType.Video
			}
		];
	}
}

export const scenarioInfoWindowVideoCaching = new ScenarioInfoWindowVideoCaching();

const ScenarioInfoUI = (props: UIProperties<ScenarioInfoUIConfig>) => {
	return (
		<div className={"modal-disable-select start-scenarios-info-window-container"} style={{
		}}>
			<div style={{
				width: '1280px',
				height: '876px',
				position: 'relative',
				left: '50%',
				top: '50%',
				transform: 'translate(-50%, -50%)'
			}} className={`${constants.mainContent508Id}`} aria-label='Scenario Information'>
				<PopUp2
					titleLeft={constants.projectTitle}
					titleRight={props.parameters.scenario.title}
					subtitleRight={props.parameters.scenario.subtitle}
					onRenderContent={() => {
						return (
							<div className='start-scenarios-info-window-content'>
								<div style={{
									width: '1130px',
									height: '410px',
									position: 'absolute',
									left: '4px',
									top:' 40px',
									backgroundColor: '#D3E1EA',
									borderRadius: '20px'
								}}></div>
								<div className='scenario-info-window-content-hero-container'>
									<MentorUI mediaId={mediaId} talkingVideoSrc={props.parameters.scenario.mentorVideoUrl} chapterId={props.parameters.scenario.mentorChapterId}></MentorUI>
								</div>
								<div className='background1 scenario-info-window-content-details-container text-manual-edit-p' dangerouslySetInnerHTML={{ __html: parseDynamicHtml(props.parameters.scenario.description) }}>

								</div>

								{/* <div className='background1 scenario-info-window-content-progress-container'>
									<ProgressBar1 title='Scenario Progress' textColor='black' percentage={props.parameters.getCompletionPercentage(props.parameters.scenarioSaveData)}></ProgressBar1>
								</div> */}

								<div className='scenario-info-window-content-cancel-bttn-container'>
									<Button2 width='100%'
										idFor508='scenario-info-content-top'
										height='100%'
										onClick={props.parameters.onReturnToMainMenuClicked}
										hoverBgColor='#bfddff'
										backgroundColor={undefined}
										onRenderContent={() => {
											return (
												<div className='scenario-info-window-content-btn'>
													<img className='scenario-info-window-content-btn-img center-element-vertical' src={scenarioInfoWindowCaching.getItemByKey('return1').src} />
													<p className='scenario-info-window-content-btn-text center-element-vertical text-manual-edit-p'>Return to Main Menu</p>
												</div>
											)
										}}
										isSelected={false}
										ariaLabel='Return to Main Menu'></Button2>
								</div>

								<div style={{
									width: '990px',
									height: '100px',
									position: 'absolute',
									top: '460px',
									left: '50%',
									transform: 'translatex(-50%)'
								}}>
									<MediaControlsUI mediaId={mediaId}></MediaControlsUI>
								</div>

								<div className='scenario-info-window-content-confirm-bttn-container'>
									<Button2 width='100%'
										idFor508='scenario-info-content-bottom'
										height='100%'
										onClick={() => props.parameters.onStartScenarioClicked(props.parameters.scenario.scenarioId)}
										hoverBgColor='#bfddff'
										backgroundColor={undefined}
										onRenderContent={() => {
											return (
												<div>
													<p className='scenario-info-window-content-btn-confirm-text center-element-vertical text-manual-edit-p'>Start Scenario</p>
													<div className='scenario-info-window-content-arrow center-element-vertical'>
														<CoreArrow1></CoreArrow1>
													</div>
												</div>
											)
										}}
										isSelected={false}
										ariaLabel='Start Scenario'></Button2>
								</div>
							</div>
						);
					}}></PopUp2>
			</div>
			
		</div>
	);
};

export interface ScenarioInfoUIConfig {
	scenario: SingleScenarioInfoConfig;
	scenarioSaveData: SingleScenarioConfig;
	onReturnToMainMenuClicked: () => void;
	onStartScenarioClicked: (page: PageType) => void;
	getCompletionPercentage: (scenario: SingleScenarioConfig) => number;
}

export interface SingleScenarioInfoConfig {
    scenarioId: PageType;
    title: string;
    subtitle: string;
    description: string;
    img: string;
	mentorVideoUrl: string;
	mentorChapterId: string;
}

export default ScenarioInfoUI;